/**
 * @fileoverview CSS module for the NoTest component.
 * Provides styling for the NoTest component, which displays a message when no tests are found.
 *
 * @example
 * // Usage in a component:
 * import styles from './NoTest.module.css'
 *
 * function NoTest() {
 *   return <div className={styles.container}>No tests found</div>
 * }
 */

.container {
    font-family: 'Inter', 'system-ui';
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1rem;
}

.caption {
    font-size: 1.5rem;
    font-weight: 700;
    font-weight: 500;
}

.description {
    text-underline-offset: 4px;
}
